export const selectCategories = state => state.categories.categories;